import useScrollReveal from '../hooks/useScrollReveal';

export default function FeatureTile({ iconSrc, title, body, delay = 0 }) {
  const [ref, visible] = useScrollReveal();

  return (
    <div
      ref={ref}
      className={`feature-tile reveal ${visible ? 'visible' : ''}`}
      style={{ transitionDelay: visible ? `${delay}ms` : '0ms' }}
    >
      <img src={iconSrc} alt="" className="feature-icon" aria-hidden="true" />
      <div className="feature-title">{title}</div>
      <div className="feature-body">{body}</div>
    </div>
  );
}
